import { render, staticRenderFns } from "./ReminderModal.vue?vue&type=template&id=46ffef05&scoped=true&lang=pug&"
import script from "./ReminderModal.vue?vue&type=script&lang=js&"
export * from "./ReminderModal.vue?vue&type=script&lang=js&"
import style0 from "./ReminderModal.vue?vue&type=style&index=0&id=46ffef05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ffef05",
  null
  
)

export default component.exports